import classNames from 'classnames';
import React from 'react';
import { areEqual, FixedSizeList, ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import {
  fightingRankItemSelector,
  fightingRankListSelector
} from 'src/modules/imagesV3/store/selector';
import EmptyPlaceholder from '../../EmptyPlaceholder';
import ImageStars from '../../ImageStars';
import { LIST_HEIGHT, RATIO } from '../list';
import RankItem from '../RanItem';
import styles from './index.module.scss';

const Row = React.memo(({ index, style, data }: ListChildComponentProps) => {
  const item = useRecoilValue(fightingRankItemSelector(data[index]));
  if (!item) return null;
  return (
    <div style={style}>
      <RankItem
        rank={index + 1}
        score={item.score}
        renderLogo={() => (
          <div
            className={classNames(
              styles.avatar,
              index < 3 && styles[`rank${index + 1}`]
            )}
            style={{ backgroundImage: `url(${item.logoUrl})` }}
          />
        )}
        renderInfo={() => (
          <div className={styles.info}>
            <div className={styles.title}>{item.title}</div>
            <ImageStars count={item.starLevel} />
            <div className={styles.owner}>拥有者：{item.nickname}</div>
          </div>
        )}
      />
    </div>
  );
}, areEqual);
const FightingRank = () => {
  const list = useRecoilValue(fightingRankListSelector);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>排名</div>
        <div>座驾信息</div>
        <div>战斗力</div>
      </div>
      <EmptyPlaceholder
        style={{ height: LIST_HEIGHT }}
        hasValue={list.length > 0}
      >
        <FixedSizeList
          className={styles.container}
          height={LIST_HEIGHT}
          itemSize={130 * RATIO}
          itemCount={list.length}
          width="100%"
          itemData={list}
        >
          {Row}
        </FixedSizeList>
      </EmptyPlaceholder>
    </div>
  );
};

export default React.memo(FightingRank);
